<template>
    <div class="wrapper" id="app">
        <the-header></the-header>
        <main class="main" :class="{ 'main--no-padding': [ 'page_not_found'].includes($route.name) }">
            <transition name="fade" mode="out-in">
                <router-view></router-view>
            </transition>
        </main>
        <the-footer />
        <cookie-notification />
        <confirmation-modal />
    </div>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import TheFooter from '@/components/general/TheFooter';
    import TheHeader from '@/components/general/TheHeader';
    import CookieNotification from '@/components/cookies/CookieNotification';
    import ConfirmationModal from '@/components/modals/ConfirmationModal';
    import { USER_PROFILE } from './store/modules/auth';

    @Component
    export default class App extends Vue {
        name = 'app';

        created() {
            if (this.$store.state.auth.token) this.$store.dispatch(USER_PROFILE);
        }

    }
</script>

<!-- Import SCSS boilerplate -->
<style src="./assets/css/styles.scss" lang="scss"></style>




// WEBPACK FOOTER //
// src/App.vue